import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { Row, Col, FormControl } from 'react-bootstrap';
import '@styles/JobGeneral.css';
import { ROUTER, STRING, NUMBER } from '@constants/Constant';
import DatePickerCustom from '../../../components/DatePickerCustom';

class StatisticScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      [STRING.fromDate]: '',
      [STRING.toDate]: '',
    };
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value || '',
    });
  };

  renderTitle() {
    return (
      <>
        <Row>
          <Col sm={12}>
            <h2 className="text-left" style={{ marginBottom: '10px' }}>
              {' '}
              Báo cáo kết quả nhân viên
            </h2>
            <div class="line"></div>
          </Col>
        </Row>
      </>
    );
  }

  renderBody() {
    return (
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <Row
            className="mt-1"
            style={{ textAlign: 'center', padding: '0px 20px', borderRadius: '8px', marginBottom: 30 }}
          >
            <Col md className="bg">
              {this.renderTitle()}
              {this.renderField()}
            </Col>
          </Row>
          <Row
            className="mt-1"
            style={{ padding: '0px 20px', borderRadius: '8px', marginBottom: 30 }}
          >
            <Col md className="bg">
              <Row>
                <Col md={12}>{this.renderTable()}</Col>
              </Row>
              {/* <Row>
                <Col md={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  {this.renderPagination()}
                </Col>
              </Row> */}
            </Col>
          </Row>
        </div>
      </div>
    );
  }

  renderField() {
    const { name, [STRING.fromDate]: fromDate, [STRING.toDate]: toDate } = this.state;
    return (
      <div className="w-100">
        <Row>
          <Col md={4} sm={12}>
            <FormControl
              type="text"
              id=""
              placeholder="Tên hoặc số điện thoại Sale"
              value={name}
              onChange={(e) => this.handleChange('name', e.target.value)}
            />
          </Col>
          <Col md={4} sm={12}>
            <DatePickerCustom
              className={`date-picker form-control`}
              placeholderText={STRING.fromDate}
              handleChange={this.handleChange}
              selected={fromDate}
              maxDate={new Date(toDate)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
          <Col md={4} sm={12}>
            <DatePickerCustom
              className={`date-picker form-control`}
              placeholderText={STRING.toDate}
              handleChange={this.handleChange}
              selected={toDate}
              minDate={new Date(fromDate)}
              dateFormat="dd/MM/yyyy"
            />
          </Col>
        </Row>
      </div>
    );
  }

  renderTable() {
    return (
      <div className="w-100 table-wrap">
        <span className="pb-2 d-inline-block">
          Kết quả lọc: <b className="text-danger">230</b>
        </span>
        <Table bordered>
          <thead>
            <tr>
              <th>STT</th>
              <th>Họ tên</th>
              <th>Công việc tham gia</th>
              <th>Tiến độ</th>
              <th>Không nghe máy</th>
              <th>Bận gọi lại sau</th>
              <th>Sai thông tin</th>
              <th>Đồng ý trao đổi</th>
              <th>Bị gián đoạn</th>
              <th>T/gian gọi trung bình</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowSpan="3">1</td>
              <td rowSpan="3">Nguyễn Tài Thao</td>
              <td>Chăm sóc khách hàng</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
            <tr>
              <td>Tư vấn khách hàng</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
            <tr>
              <td>Đòi nợ thuê</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
            <tr>
              <td rowSpan="3">2</td>
              <td rowSpan="3">Nguyễn Thị Thảo</td>
              <td>Chăm sóc khách hàng</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
            <tr>
              <td>Tư vấn khách hàng</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
            <tr>
              <td>Đòi nợ thuê</td>
              <td>100/250</td>
              <td>50</td>
              <td>130</td>
              <td>70</td>
              <td>250</td>
              <td>20</td>
              <td>20:30 phút/ngày</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  addFieldChange = (field, value) => {
    this.setState({
      ...this.state,
      modalAddField: {
        ...this.state.modalAddField,
        [field]: value,
      },
    });
  };

  render() {
    return <>{this.renderBody()}</>;
  }
}

export default withRouter(StatisticScreen);
